import api from "../http";
import {trackEvent} from '../analytics/analytics';

const getFollow = () => {
    return api
        .get("/follow")
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error
        });

};

const addFollow = (author_id) => {
    return api
        .post("/follow", {
            "author_id": author_id
        })
        .then((response) => {
            if (response.status === 200 && response.data?.message === 'Вы подписались на автора') {
                trackEvent('follow_author_success', {outcome: 'success'});
            }
            return response;
        })
        .catch((error) => {
            throw error
        });

};

const removeFollow = (author_id) => {
    return api
        .delete("/follow", {
            params: {
                "author_id": author_id
            }
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            throw error
        });

};

let followService = {
    getFollow,
    addFollow,
    removeFollow
}

export default followService
